import {Box, Paper} from "@mui/material";

const StyledPaper = ({ children }) => (
    <Paper elevation={3}>
        <Box sx={{p: '32px 16px' }}>
            {children}
        </Box>
    </Paper>
);

export default StyledPaper;